import React from 'react';

export default function DomainInfoLoading() {
  return (
    <div className="domain-info-loading">Domain info loading...</div>
  );
}
